import { Injectable } from '@angular/core';
import { fetchAuthSession, getCurrentUser, signInWithRedirect, signOut } from 'aws-amplify/auth';

@Injectable({
  providedIn: 'root'
})
export class AmplifyAuthAdapterService {
  fetchAuthSession = fetchAuthSession;
  getCurrentUser = getCurrentUser;
  signOut = signOut;
  signInWithRedirect = signInWithRedirect;
}
